import axios from "axios";
import LocalStorageWrapper, { LocalStorageKeys } from "../utils/storage.utils";


const request = async (config) => {
  const bearerToken = LocalStorageWrapper.get(LocalStorageKeys.TOKEN);
  const $axios = axios.create({baseURL: process.env.REACT_APP_BASE_URL});
  config.headers = {
    ...config.headers,
    Accept: "application/json",
    "Content-Type": "application/x-www-form-urlencoded",
    ...(bearerToken
      ? {
          Authorization: bearerToken,
        }
      : {}),
  };

  $axios.interceptors.response.use(async (response) => {
    const { data } = response;
    if (data.message === "Token Expired") {
      LocalStorageWrapper.clear();
      window.location.reload();
    } else {
      return response;
    }
  });

  const returnValue = await $axios({ ...config });
  // console.log("response:", returnValue)
  return returnValue;
};

export const reqGet = async (config) =>
  request({
    method: "GET",
    ...config,
  });

export const reqPost = async (config) =>
  request({
    method: "POST",
    ...config,
  });

export const reqDelete = async (config) =>
  request({
    method: "DELETE",
    ...config,
  });
